import { create } from 'zustand';

import { ITicketListRefreshStore } from './type';

export const useTicketListRefresh = create<ITicketListRefreshStore>((set) => ({
  data: false,
  setter: (data) => {
    set({ data: data });
  },
}));
